export default __webpack_public_path__ + "static/media/valorant_phonenix.780c51b2.png";